import { useLocalStorage } from 'modules/shared/hooks/use-local-storage';
import { StorageKey } from 'modules/shared/shared.types';
export var useToken = function () { return useLocalStorage(StorageKey.TOKEN, ''); };
